import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { ROUTES } from "../../app/utils/CONSTANTS";
import axios from "axios";

const initialState = {
  data: null,
  status: "idle", 
  error: null as string | null,
  response: null as any,
};

export const addCareerCard = createAsyncThunk(
  "addCareerCard/addCareerCard",
  async (payload: any, { rejectWithValue }) => {
    try {
      const response: { success: boolean; data: any } = await axios({
        method: "post", 
        url: ROUTES.addCareerCard,
        data: payload,
        withCredentials : true
      });
      return response;
    } catch (error: any) {
      return rejectWithValue(error.message || "Failed to add career card");
    }
  }
);

const addCareerCardSlice = createSlice({
  name: "addCareerCard",
  initialState,
  reducers: { 
    resetaddCareerCard: (state) => {
        state.data= null;
        state.status= "idle";
        state.error= null;
        state.response=null;
    }},
  extraReducers: (builder) => {
    builder
      .addCase(addCareerCard.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(addCareerCard.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.data = action.payload.data as any;
      })
      .addCase(addCareerCard.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload as string;
      });
  },
});

export const { resetaddCareerCard } = addCareerCardSlice.actions;

export default addCareerCardSlice.reducer;
